import React from "react"
import CTAButton from "src/components/common/CTAButton"
import { StyledSplitSection } from "src/components/common/StyledSplitSection"
import styled from "styled-components"

const AddOurChannelSection = () => {
  return (
    <StyledAddOurChannelSection>
      <div className="content-side">
        <div className="content">
          <h2>
            Add Our Channel <br />
            to Your Platform
          </h2>
          <p>
            Energize your platform’s channel lineup with our unique mix of
            sports, entertainment and original programming.
          </p>
          <CTAButton link="mailto:bizdev@fubo.tv">Contact Us</CTAButton>
        </div>
      </div>
      <div className="image-side">
        <div className="image-container">
          <div className="image">
            <img
              src="https://assets-imgx.fubo.tv/marketing/lp/images/fsn/contact/add-our-channel-2025.jpg?ch=width&auto=format,compress"
              alt=""
            />
          </div>
        </div>
      </div>
    </StyledAddOurChannelSection>
  )
}

export default AddOurChannelSection

const StyledAddOurChannelSection = styled(StyledSplitSection)`
  background: linear-gradient(180deg, #2c2f3d 2.19%, #161822 98.44%);
  @media (max-width: 767px) {
    flex-direction: column;
    .image-side {
      align-self: flex-end;
    }
  }
  .content-side {
  }
  .image-side {
    .image-container {
      border-right: none;
      border-radius: 300px 0 0 300px;
      padding: 10px 0 10px 10px;
      .image {
        border-radius: 300px 0 0 300px;
      }
    }
  }
`
